const state = {
  catch_components: [],
}

const mutations = {
  CHANGE_CATCH_COMPONENTS: (state, data) => {
    let ind = state.catch_components.findIndex((item, index) => {
      return item == data
    })
    if (ind > -1) {
      state.catch_components.splice(ind, 1, data)
    } else {
      state.catch_components.push(data)
    }
    // console.log('添加:', state.catch_components)
  },
  DEL_CATCH_COMPONENTS: (state, data) => {
    let ind = state.catch_components.findIndex((item, index) => {
      return item == data
    })
    if (ind > -1) {
      state.catch_components.splice(ind, 1)
    }
    // console.log('删除:', state.catch_components)
  },
  DELALL: (state, data) => {
    state.catch_components = []
  },
}

const actions = {
  changeCatchComponents({commit}, data) {
    return new Promise(resolve => {
      commit('CHANGE_CATCH_COMPONENTS', data)
      resolve()
    })

  },
  delCatchComponents({commit}, data) {
    commit('DEL_CATCH_COMPONENTS', data)
  },
  delAll({commit}, data) {
    commit('DELALL')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/catchComponents.js